import { Grid, TextField, Button } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { SystemPageFilters } from './types';

interface Props {
  control: Control<SystemPageFilters>;
  clearFilters: () => void;
}

const SwitchesFilters = ({ control, clearFilters }: Props) => {
  return (
    <>
      <Controller
        name='switchName'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='switchName'
              label='Filter By Device Name'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Controller
        name='analyzerSwitchName'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='analyzerSwitchName'
              label='Filter By Connected Analyzer'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Grid item>
        <Button variant='contained' color='primary' onClick={clearFilters}>
          Clear Filters
        </Button>
      </Grid>
    </>
  );
};

export default SwitchesFilters;
